import { MessageBarActions, MessageBarBody } from '@fluentui/react-message-bar';
import { appearance } from 'src/hooks/useAlertMessage';
import { Button } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { MessageBarContainer } from './styles/AlertMessageStyles.styled';

interface AlertProps {
  requestStatusAppearance: appearance;
  requestStatusMessage: string;
  overlay?: boolean;
  showCloseButton?: boolean;
  multiline?: boolean;
  isCentered?: boolean;
  handleClose: () => void;
}

export const Alert = ({
  handleClose,
  requestStatusAppearance,
  requestStatusMessage,
  overlay = false,
  showCloseButton = true,
  multiline = false,
  isCentered = false,
}: AlertProps) => {
  return (
    <MessageBarContainer
      intent={requestStatusAppearance}
      overlay={overlay}
      layout={multiline ? 'multiline' : 'singleline'}
      isCentered={isCentered}
    >
      <MessageBarBody>{requestStatusMessage}</MessageBarBody>
      <MessageBarActions
        containerAction={
          showCloseButton ? (
            <Button
              onClick={handleClose}
              appearance="transparent"
              icon={<DismissRegular />}
            />
          ) : null
        }
      ></MessageBarActions>
    </MessageBarContainer>
  );
};
